<template>
  <span v-if="item">
    {{ item.credit }}({{ item.lect_hr }}-{{ item.prac_hr }}-{{ item.self_hr }})
    <lect-or-prac-chip v-if="show_lect_or_prac" :item="item"></lect-or-prac-chip>
  </span>
</template>

<script>
import LectOrPracChip from "./LectOrPracChip.vue";
export default {
  name: "ClassHourText",
  components: {
    LectOrPracChip,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    show_lect_or_prac: {
      type: Boolean,
      default: false,
    },
  },
};
</script>